













































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    SdsIcon,
    SdsButtonText,
} from '@superbet-group/web.lib.ui-components';
import { Condition } from '@app/promotionHub/shared/types/Condition';
import { BonusRequirement } from '@app/promotionHub/bonuses/utils/types';
import { BonusKind } from '@core/models/bonus/Bonus';
import { isBetlerBonus } from '@app/promotionHub/bonuses/utils/bonusHelpers';
import {
    useI18n,
    isMobileLayout,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    translationBoldFormat,
    translationPlaceholderFormat,
} from '@superbet-group/web.lib.utilities';
import { getCustomContentLabel } from '@app/promotionHub/bonuses/utils/presentation';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import promotionStoreIndex from '@store/modules/ui/user/promotions/promotionIndex';
import { PromotionHubTab } from '@app/promotionHub/shared/types/promotionHubTab';

export default defineComponent({
    name: 'RulesAndRestrictionsSection',
    props: {
        title: {
            type: String,
            required: false,
            default: 'bonus.common.how_to_use',
        },
        conditions: {
            type: Array as PropType<Condition[] | BonusRequirement[]>,
            required: false,
            default: () => [],
        },
        kind: {
            type: String as PropType<BonusKind>,
            required: true,
        },
        promotionId: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        termsAndConditionsUrl: {
            type: String,
            required: false,
            default: '',
        },
        isBonusType: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(props) {
        const { translate } = useI18n();

        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');

        const promoModule = useVuexStore<typeof promotionStoreIndex>('ui/user/promotions');
        const setActivePromotionHubTab = promoModule.action('setActivePromotionHubTab');

        function conditionText(bonusRequirement: Condition | BonusRequirement): string {
            if (isBetlerBonus(props.kind) && !props.promotionId) {
                return translationBoldFormat(translationPlaceholderFormat(translate((bonusRequirement as BonusRequirement).text), {
                    condition: (bonusRequirement as BonusRequirement)?.condition ? translate((bonusRequirement as BonusRequirement).condition!.toString()) : '',
                    currency: bonusRequirement.isCurrency ? translate('currencyAbbreviation') : '',
                }));
            } else {
                return getCustomContentLabel(bonusRequirement as Condition);
            }
        }

        function openTerms() {
            if (props.termsAndConditionsUrl) {
                window.open(props.termsAndConditionsUrl, '_blank');
            } else if (props.isBonusType) {
                setActivePromotionHubTab(PromotionHubTab.Offers);
            }
        }

        function openTooltipPreview(bonusAdditionalInfo: string) {
            if (isMobileLayout()) {
                setModal({
                    code: modalCodes.tooltipInfo,
                    data: {
                        title: translate('bonus.card.usage_tooltip'),
                        bonusConditions: bonusAdditionalInfo,
                    },
                });
            }
        }

        return {
            conditionText,
            openTerms,
            bonusTooltipInfo: (bonusAdditionalInfo: string) => !isMobileLayout() ? `${translate('bonus.card.usage_tooltip')}<br>${bonusAdditionalInfo}` : '',
            openTooltipPreview,
        };
    },
    components: {
        SdsIcon,
        SdsButtonText,
    },
});
